import { render, staticRenderFns } from "./details-color-picker.vue?vue&type=template&id=e2f391a2&"
import script from "./details-color-picker.vue?vue&type=script&lang=ts&"
export * from "./details-color-picker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\wamp\\www\\Pentacom\\baumit.com\\vue-project\\calculator-common\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2f391a2')) {
      api.createRecord('e2f391a2', component.options)
    } else {
      api.reload('e2f391a2', component.options)
    }
    module.hot.accept("./details-color-picker.vue?vue&type=template&id=e2f391a2&", function () {
      api.rerender('e2f391a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/details-color-picker/details-color-picker.vue"
export default component.exports